/** Degrees to radians (a definition). */
export const DEG = Math.PI / 180;
